import { CByteArray } from "./CByteArray";

// typedef struct tagLoginPlayer {
// 	HOSTID	idxLS;
// 	HOSTID	index;
// 	int		DBID;
// 	int		RoomCards;		// 房卡數
// 	int		idTable;

// int		Gold;
// int		Guild;
// 	char	guildName[GUILDNAME_LEN];

// 	char	flags[FLAG_LEN];
// 	char	openid[OPENID_LEN];		// 帳號
// 	char	socialName[NICKNAME_LEN];
// 	char	EMail[EMAIL_LEN];
// 	char	pictureURL[PICTUREURL_LEN];
// } LOGINPLAYER, *LPLOGINPLAYER;

export class CLoginPlayer {
    public static OPENID_LEN:number = 60;
    public static NICKNAME_LEN:number = 40;
    public static EMAIL_LEN:number = 128;
    public static IP_LEN:number = 48;
    public static PICTUREURL_LEN:number = 384;
    public static FLAG_LEN:number = 20;
    public static GUILDNAME_LEN:number = 25;

    public static DATA_SIZE:number = CLoginPlayer.OPENID_LEN+CLoginPlayer.NICKNAME_LEN+
                CLoginPlayer.IP_LEN+CLoginPlayer.PICTUREURL_LEN+//CLoginPlayer.GUILDNAME_LEN+
                CLoginPlayer.FLAG_LEN+4*7;

    protected static ofsIndexLS:number = 0;
    protected static ofsIndex:number = CLoginPlayer.ofsIndexLS + 4;
    protected static ofsDBID:number = CLoginPlayer.ofsIndex + 4;
    protected static ofsRoomCards:number = CLoginPlayer.ofsDBID + 4;
    protected static ofsTable:number = CLoginPlayer.ofsRoomCards + 4;

    protected static ofsGold:number = CLoginPlayer.ofsTable + 4;
    protected static ofsGuild:number = CLoginPlayer.ofsGold + 4;

	protected static ofsFlags:number = CLoginPlayer.ofsGuild + 4;
    protected static ofsOpenid:number = CLoginPlayer.ofsFlags + CLoginPlayer.FLAG_LEN;
    protected static ofsSocialname:number = CLoginPlayer.ofsOpenid + CLoginPlayer.OPENID_LEN;
    protected static ofsIP:number = CLoginPlayer.ofsSocialname + CLoginPlayer.NICKNAME_LEN;
    protected static ofsPictureURL:number = CLoginPlayer.ofsIP + CLoginPlayer.IP_LEN;
    
    protected m_Data:CByteArray;

    public constructor() {
        this.m_Data = new CByteArray(CLoginPlayer.DATA_SIZE);
    }

    public getData():CByteArray { return this.m_Data; }

    public get idxLS():number { return this.m_Data.GetInt(CLoginPlayer.ofsIndexLS); }
	public get index():number { return this.m_Data.GetInt(CLoginPlayer.ofsIndex); }
	public get DBID():number { return this.m_Data.GetInt(CLoginPlayer.ofsDBID); }
	public get RoomCards():number { return this.m_Data.GetInt(CLoginPlayer.ofsRoomCards); }
	public get idTable():number { return this.m_Data.GetInt(CLoginPlayer.ofsTable); }

    public get Gold():number { return this.m_Data.GetInt(CLoginPlayer.ofsGold); }
    public get Guild():number { return this.m_Data.GetInt(CLoginPlayer.ofsGuild); }
    //public get GuildName():string { return this.m_Data.GetUTFBytes(CLoginPlayer.ofsGuildName, CLoginPlayer.GUILDNAME_LEN); }

	public get openid():string { return this.m_Data.GetUTFBytes(CLoginPlayer.ofsOpenid, CLoginPlayer.OPENID_LEN); }
	public get socialName():string { return this.m_Data.GetUTFBytes(CLoginPlayer.ofsSocialname, CLoginPlayer.NICKNAME_LEN); }
	//public get EMail():string { return this.m_Data.GetUTFBytes(CLoginPlayer.ofsEMail, CLoginPlayer.EMAIL_LEN); }
    public get IP():string { return this.m_Data.GetUTFBytes(CLoginPlayer.ofsIP, CLoginPlayer.EMAIL_LEN); }
	public get pictureURL():string { return this.m_Data.GetUTFBytes(CLoginPlayer.ofsPictureURL, CLoginPlayer.PICTUREURL_LEN); }

	public Flags(idx:number):number { return this.m_Data.GetByte(CLoginPlayer.ofsFlags+idx); }

	public set RoomCards(count:number) { this.m_Data.SetInt(CLoginPlayer.ofsRoomCards, count); }
	public set idTable(tbl:number) { this.m_Data.SetInt(CLoginPlayer.ofsTable, tbl); }
    public set Gold(gold:number) { this.m_Data.SetInt(CLoginPlayer.ofsGold, gold); }
    public set Guild(guild:number) { this.m_Data.SetInt(CLoginPlayer.ofsGuild, guild); }

    public set index(idx:number) { this.m_Data.SetInt(CLoginPlayer.ofsIndex, idx); }
    public set DBID(v:number) { this.m_Data.SetInt(CLoginPlayer.ofsDBID, v); }
}